import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config/config.service';
import { Observable } from 'rxjs';
import urlJoin from 'url-join';
import { SettingsService } from '../services/settings/settings.service';

export const ROUTE_TOKEN_GATEWAY_URL = '{gatewayUrl}';
export const ROUTE_TOKEN_TAX_GATEWAY_URL = '{taxGatewayUrl}';

@Injectable({
  providedIn: 'root'
})
export class GatewayUrlInterceptorService implements HttpInterceptor {
  constructor(
    private readonly configService: ConfigService,
    private readonly settingsService: SettingsService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hasGatewayToken = request.url.includes(ROUTE_TOKEN_GATEWAY_URL);
    const hasTaxGatewayToken = request.url.includes(ROUTE_TOKEN_TAX_GATEWAY_URL);

    if (!hasGatewayToken && !hasTaxGatewayToken) {
      return next.handle(request);
    }

    let baseUrl: string;
    let urlWithoutToken: string;
    let pageKey: string;

    if (hasGatewayToken) {
      baseUrl = this.configService.gatewayUrl;
      urlWithoutToken = request.url.split(ROUTE_TOKEN_GATEWAY_URL)[1];
      pageKey = this.configService.gatewayExternalPageKey;
    } else {
      baseUrl = this.configService.taxGatewayUrl;
      urlWithoutToken = request.url.split(ROUTE_TOKEN_TAX_GATEWAY_URL)[1];
      pageKey = this.configService.taxGatewayExternalPageKey;
    }

    if (this.settingsService.useProxy &&
        this.configService.externalUrlPrefix &&
        pageKey) {
      baseUrl = urlJoin(
        '/',
        this.configService.externalUrlPrefix,
        pageKey
      );
    }

    const newRequest = request.clone({
      url: urlJoin(baseUrl, urlWithoutToken),
    });

    return next.handle(newRequest);
  }
}
